/**
 * Tiny logger used by the version-watcher modules. Keeps a record of the
 * most recent event name so the debug panel can show what fired last.
 */

let lastLoggedEvent: string | null = null;

export function vwlog(event: string, data: Record<string, unknown> = {}): void {
  lastLoggedEvent = event;
  try {
    // eslint-disable-next-line no-console
    console.log(`[VersionWatcher][${event}]`, data);
  } catch {
    /* ignore */
  }
}

export function _vwGetLastEvent(): string | null {
  return lastLoggedEvent;
}
